import React from 'react';
import { notification } from 'antd/';
import '@ant-design/v5-patch-for-react-19';
/**
 * Displays a formatted Ant Design notification.
 * 
 * @param {('success'|'error'|'info'|'warning')} type - Type of the notification.
 * @param {string|object} errorData - JSON string or object containing error information.
 */
const createNotification = (type = 'success', errorData) => {
  let parsedData = {
    status: 'Error',
    message: 'Something went wrong.',
    details: {},
  };
  console.log('createNotification called with type:', type, 'and errorData:', errorData);

  // Try to parse errorData
  try {
    if (typeof errorData === 'string') {
      parsedData = JSON.parse(errorData);
    } else if (typeof errorData === 'object' && errorData !== null) {
      parsedData = errorData;
    }
  } catch (err) {
    console.warn('Failed to parse errorData:', err);
  }

  const { status = 'Error', message = 'Something went wrong', details = {} } = parsedData;

  const formattedMessage = `${status}: ${message}`;

  const formattedDescription = (
    <div>
      {Object.entries(details).map(([key, value]) => (
        <p key={key}>
          <strong>{key}</strong>: {String(value)}
        </p>
      ))}
    </div>
  );

  notification[type]({
    message: formattedMessage,
    description: formattedDescription,
  });
};

export default createNotification;
